var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
var RingGraphSettingComponent = /** @class */ (function (_super) {
    __extends(RingGraphSettingComponent, _super);
    function RingGraphSettingComponent(injector, changeDetector, bsModalRef) {
        var _this = _super.call(this, injector, 'RingGraphSettingModal') || this;
        _this.changeDetector = changeDetector;
        _this.bsModalRef = bsModalRef;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(RingGraphSettingComponent.prototype, "allSettings", {
        get: function () {
            return this.arg.allSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphSettingComponent.prototype, "generalSetting", {
        get: function () {
            return this.allSettings.generalSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphSettingComponent.prototype, "expendSetting", {
        get: function () {
            return this.allSettings.expendSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphSettingComponent.prototype, "calibrationMarkSetting", {
        get: function () {
            return this.allSettings.calibrationMarkSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphSettingComponent.prototype, "configureId", {
        get: function () {
            return this.arg.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RingGraphSettingComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    RingGraphSettingComponent.prototype.ngOnInit = function () {
        this.active = true;
        this.changeDetector.detectChanges();
        this.init(this.arg.model);
    };
    RingGraphSettingComponent.prototype.onShown = function () {
        $(this.generalSettingCmp.startAngleInput.nativeElement).focus();
    };
    RingGraphSettingComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.staticTabs.tabs[0].active = true;
    };
    RingGraphSettingComponent.prototype.save = function () {
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(3);
            return;
        }
        this.closeModal(this.allSettings);
    };
    RingGraphSettingComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    RingGraphSettingComponent.prototype.closeModal = function (data) {
        this.saving = false;
        this.active = false;
        this._onClosed.next(data);
        this._onClosed.complete();
        this.bsModalRef.hide();
    };
    __decorate([
        ViewChild('generalSettingCmp', { static: false })
    ], RingGraphSettingComponent.prototype, "generalSettingCmp", void 0);
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], RingGraphSettingComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], RingGraphSettingComponent.prototype, "staticTabs", void 0);
    RingGraphSettingComponent = __decorate([
        Component({
            selector: 'ring-graph-setting',
            template: "<form name='ringGraphSettingModal' bs-modal-drag id=\"ringGraphSettingModal\" class=\"configure\" *ngIf=\"active\" #ringGraphForm=\"ngForm\" novalidate (onShown)=\"onShown()\" (ngSubmit)=\"save()\"> <div class=\"fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"RingGraph\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"closeModal()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <ring-graph-general [configureId]=\"configureId\" #generalSettingCmp [data]=\"generalSetting\"></ring-graph-general> </tab> <tab heading=\"{{lc('ExtendProperty')}}\" customClass=\"m-tabs__item\"> <extend-property #expendSettingCmp [data]=\"expendSetting\"></extend-property> </tab> <tab heading=\"{{lc('CalibrationAndMarker')}}\" customClass=\"m-tabs__item\"> <calibration-mark #calibrationMark [data]=\"calibrationMarkSetting\" [displayPercentage]=\"true\"></calibration-mark> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isSameSize]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"ringGraphForm.form.invalid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"closeModal()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </form> "
        })
    ], RingGraphSettingComponent);
    return RingGraphSettingComponent;
}(ResizableElementSettingModal));
export { RingGraphSettingComponent };
